// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  eventId: __t.u64().primaryKey().name("event_id"),
  host: __t.identity(),
  worldId: __t.u64().name("world_id"),
  title: __t.string(),
  theme: __t.string(),
  startAt: __t.timestamp().name("start_at"),
  recurrence: __t.string(),
  ticketPriceSov: __t.i64().name("ticket_price_sov"),
  attendanceTarget: __t.u32().name("attendance_target"),
  checkedInCount: __t.u32().name("checked_in_count"),
  hostInfPaid: __t.bool().name("host_inf_paid"),
  hostBonusPaid: __t.bool().name("host_bonus_paid"),
  memorialCreated: __t.bool().name("memorial_created"),
  createdAt: __t.timestamp().name("created_at"),
});
